var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWrenchPlanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9858 17.325C15.4431 17.6003 15.9662 17.7472 16.5 17.75C17.2954 17.7491 18.0579 17.4328 18.6203 16.8703C19.1828 16.3079 19.4991 15.5454 19.5 14.75C19.4965 14.4905 19.4589 14.2326 19.3881 13.9829L17.5606 15.8106C17.4213 15.9498 17.2557 16.0599 17.0738 16.1352C16.8919 16.2106 16.6969 16.2493 16.5 16.2493C16.3031 16.2493 16.1081 16.2106 15.9262 16.1352C15.7443 16.0599 15.579 15.9494 15.4398 15.8102C15.3006 15.671 15.1901 15.5057 15.1148 15.3238C15.0394 15.1419 15.0007 14.9469 15.0007 14.75C15.0007 14.5531 15.0394 14.3581 15.1148 14.1762C15.1901 13.9943 15.3006 13.829 15.4398 13.6898L17.267 11.8618C17.0174 11.7911 16.7595 11.7535 16.5 11.75C15.7046 11.7509 14.9421 12.0673 14.3797 12.6297C13.8173 13.1921 13.5009 13.9546 13.5 14.75C13.5029 15.2838 13.6497 15.807 13.9252 16.2643L9.75 20.4395L10.8106 21.5L14.9858 17.325Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 2H13.5V0.5H12V2H6V0.5H4.5V2H1.5C1.10218 2 0.720644 2.15804 0.43934 2.43934C0.158035 2.72064 0 3.10218 0 3.5V18.5C0 18.8978 0.158035 19.2794 0.43934 19.5607C0.720644 19.842 1.10218 20 1.5 20H7.5V18.5H1.5V3.5H4.5V5H6V3.5H12V5H13.5V3.5H16.5V9.5H18V3.5C18 3.10218 17.842 2.72064 17.5607 2.43934C17.2794 2.15804 16.8978 2 16.5 2Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrenchPlanner);
export default __webpack_public_path__ + "static/media/wrench_planner.ce47272c9dcb22b69dcae6ecccf849b0.svg";
export { ForwardRef as ReactComponent };